import { TeamRole } from '@showbie-socrative/socrative-utils';
import { UseQueryResult } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

/**
 * Custom hook to get the role of the acting user on the selected team.
 *
 * This hook uses the selected team ID from the global state and retrieves the role
 * of the acting user on that team by filtering the list of teams.
 *
 */
export function useRoleOnSelectedTeam(): UseQueryResult<TeamRole, unknown> {
  // Get the ID of the selected team from the global state
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);

  // Use the useTeams hook to get the role of the acting user on the selected team
  return useTeams({
    select: (teams) => teams.find((team) => team.id === selectedTeamId)?.role,
  });
}
